<template>
  <div class="home-inicio">
    <!-- Encabezado con logo y toggle en móvil -->
    <header class="header-top">
      <div class="logo">Miss Coquette</div>
      <button class="toggle-button" @click="toggleSidebar">
        <i class="fas fa-bars"></i>
      </button>
    </header>

    <!-- Sidebar -->
    <aside :class="['sidebar', { 'sidebar-mobile-visible': isSidebarVisible }]">
      <div class="section" @click="navigateTo('inventory')">
        <i class="fas fa-boxes icon"></i>
        <h2>Alta de Inventario</h2>
        <p>Gestiona tus productos y añade nuevos al inventario.</p>
      </div>
      <div class="section" @click="navigateTo('stock')">
        <i class="fas fa-archive icon"></i>
        <h2>Ver Stock de Vestidos</h2>
        <p>Consulta el inventario actual de vestidos disponibles.</p>
      </div>
      <div class="section" @click="navigateTo('rentas')">
        <i class="fas fa-calendar-check icon"></i>
        <h2>Rentas</h2>
        <p>Consulta las rentas disponibles y realiza las gestiones necesarias.</p>
      </div>
      <div class="section" @click="navigateTo('calendario')">
        <i class="fas fa-calendar-alt icon"></i>
        <h2>Calendario</h2>
        <p>Accede al calendario para ver fechas importantes.</p>
      </div>
      <div class="section" @click="navigateTo('historial')">
  <i class="fas fa-history icon"></i>
  <h2>Historial Rentas</h2>
  <p>Consulta el historial de todas las rentas.</p>
</div>
      <div class="section" @click="navigateTo('ingresos')">
        <i class="fas fa-chart-line icon"></i>
        <h2>Ingresos</h2>
        <p>Consulta y gestiona los ingresos.</p>
      </div>
      <div class="section" @click="navigateTo('egresos')">
        <i class="fas fa-exchange-alt icon"></i>
        <h2>Egresos</h2>
        <p>Consulta y gestiona los egresos.</p>
      </div>
      <div class="section" @click="navigateTo('estadisticas')">
        <i class="fas fa-chart-pie icon"></i>
        <h2>Estadísticas</h2>
        <p>Visualiza métricas clave del negocio.</p>
      </div>

      <!-- Botón Cerrar Sesión -->
      <div class="section logout" @click="logout">
        <i class="fas fa-sign-out-alt icon"></i>
        <h2>Cerrar Sesión</h2>
        <p>Salir de la plataforma.</p>
      </div>
    </aside>

    <!-- Contenido dinámico -->
    <main class="content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "HomeInicio",
  data() {
    return {
      isSidebarVisible: false,
    };
  },
  setup() {
    const router = useRouter();

    const navigateTo = (route) => {
      router.push({ name: route });

      if (window.innerWidth <= 768) {
        setTimeout(() => {
          const sidebar = document.querySelector(".sidebar");
          if (sidebar?.classList.contains("sidebar-mobile-visible")) {
            sidebar.classList.remove("sidebar-mobile-visible");
          }
        }, 100);
      }
    };

    return { navigateTo, router };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
    logout() {
      localStorage.clear();
      this.$router.push({ name: "Login" });
    }
  },
};
</script>

<style scoped>
.home-inicio {
  display: flex;
  flex-direction: row;
  height: 100vh;
}

.header-top {
  display: none;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px 20px;
  font-family: 'jour';
  font-size: 1.4rem;
  color: #c36aa0;
  border-bottom: 1px solid #eee;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
  height: 70px;
}

.toggle-button {
  background: none;
  border: none;
  font-size: 1.4rem;
  color: #c36aa0;
  cursor: pointer;
}

.sidebar {
  width: 180px;
  background-color: #fff;
  padding: 10px;
  overflow-y: auto;
  height: 100vh;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: transform 0.3s ease;
}

.section {
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  transition: 0.2s;
}

.section:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.07);
}

.section h2 {
  font-size: 1rem;
  margin: 5px 0;
  color: #333;
}

.section p {
  font-size: 0.75rem;
  color: #777;
}

.icon {
  font-size: 1.4rem;
  color: #c36aa0;
  margin-bottom: 5px;
}

.logout {
  background-color: #fff5f8;
  border: 1px solid #fdd3df;
  color: #b2365b;
}

.logout:hover {
  background-color: #fde4ec;
}

.content {
  margin-left: 190px;
  padding: 20px;
  width: calc(100% - 190px);
  background: #f6f6f9;
  overflow-y: auto;
}

/* Responsive para móvil */
@media (max-width: 768px) {
  .home-inicio {
    flex-direction: column;
  }

  .header-top {
    display: flex;
  }

  .sidebar {
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    height: auto;
    transform: translateY(-100%);
    padding: 15px 20px;
  }

  .sidebar-mobile-visible {
    transform: translateY(0);
  }

  .content {
    margin-left: 0;
    width: 100%;
    padding: 90px 20px 20px;
  }
}
</style>
